import React, { useState } from 'react';
import API from '../../../../utils/api';
import Iconify from '../../../Iconify';
import usePaymentStore from '../../shared/store/use-payment-store';
import { Tab, TabsContainer } from '../../shared/components/styled/styled';
import { showModalError } from '../../shared/components/modals/modal-error';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';
import { waitVerificationName } from '../../shared/components/modals/modal-verification-name';
import styles from './cash.module.css';
import iconoTienda from '../../shared/assets/icono-tienda.png';
import iconoBotonDescargaFicha from '../../shared/assets/icono-boton-descarga-tu-ficha.png';
import iconoDisclaimer from '../../shared/assets/icono-disclaimer.png';

const TYPE_LIST = [
  {
    id: 'cash',
    label: 'Efectivo',
    icon: 'fa6-solid:store',
  },
  {
    id: 'oxxo',
    label: 'Oxxo',
    icon: 'fa6-solid:store',
  },
];

export const CashMuwe = () => {
  const { amount, isInvalidAmount } = usePaymentStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [order, setOrder] = useState(null);
  const [type, setType] = useState(null);

  const processPayment = async () => {
    setIsSubmitting(true);
    setOrder(null);

    try {
      // const isVerified = await waitVerificationName({
      //   title: 'Verificación de nombre',
      // });

      // if (!isVerified) {
      //   alert('Por favor, verifica tu cuenta para continuar.');
      //   setIsSubmitting(false);
      //   return;
      // }

      const userCancell = await waitUserCancelCashoutsPending({
        buttonConfirm: 'Generar Referencia',
        buttonCancel: 'Cancelar',
      });

      if (userCancell) {
        setIsSubmitting(false);
        return;
      }

      const data = {
        amount: 'other',
        other_amount: amount,
        method: type,
      };

      const response = await API.createDepositOrderMuwe(data);

      if (response?.data?.success) {
        setOrder(response.data.order);
      } else {
        showModalError({ errorMessage: response.data.error });
      }
    } catch (error) {
      showModalError({ errorMessage: 'Ha ocurrido un error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const getInstructions = () => {
    if (type === 'cash') {
      return (
        <ol className={styles.orderedList}>
          <li>Elige el monto que deseas abonar a tu cuenta de Pickwin.</li>
          <li>Da click en el botón "OBTENER REFERENCIA" para generar un código de barras.</li>
          <li>Dirígete a uno de los puntos Conekta Efectivo más cercano a ti.</li>
          <li>Menciona que pagarás con ENEFEVO</li>
          <li>Muestra el código de barras</li>
          <li>Realiza tu pago y recibiras la confirmación de tu pago.</li>
        </ol>
      );
    } else if (type === 'oxxo') {
      return (
        <ol className={styles.orderedList}>
          <li>Elige el monto que deseas abonar a tu cuenta de Pickwin.</li>
          <li>Da click en el botón "OBTENER REFERENCIA" para generar un código de barras.</li>
          <li>Dirígete a uno de los puntos OXXO más cercano a ti.</li>
          <li>Menciona que pagarás con OXXOPay</li>
          <li>Muestra el código de barras</li>
          <li>Realiza tu pago y recibiras la confirmación de tu pago.</li>
        </ol>
      );
    }
  };

  const getInstructionWithOrder = () => {
    if (type === 'cash') {
      return (
        <ol className={styles.orderedList}>
          <li>Dirígete a uno de nuestros Puntos ENEFEVO.</li>
          <li>Menciona que pagarás con ENEFEVO</li>
          <li>Muestra el código de barras</li>
          <li>Realiza tu pago y recibiras la confirmación de tu pago.</li>
        </ol>
      );
    }

    if (type === 'oxxo') {
      return (
        <ol className={styles.orderedList}>
          <li>Vaya a la tienda OXXO más cercana a ti.</li>
          <li>Digale al cajero que pagarás con OXXOPay</li>
          <li>Dictar al cajero el numero de esta hoja</li>
          <li>Realice el pago en efectivo</li>
          <li>
            Para confirmar su pago, el cajero le entregara un recibo impreso. Verifique si se
            realizo correctamente el pago.
          </li>
        </ol>
      );
    }
  };
  const handleChangeType = type => {
    setType(type);
    setOrder(null);
  };

  return (
    <div className={styles.wrapper}>
      {!order && (
        <div className={styles.container}>
          {/* Selección de tipo de pago */}
          <div className={styles.options}>
            <p className={styles.selectText}>Elige donde quieres realizar tu pago.</p>
            <TabsContainer>
              {TYPE_LIST.map(method => (
                <Tab
                  key={method.id}
                  selected={method.id === type}
                  onClick={() => handleChangeType(method.id)}
                >
                  <Iconify icon={method.icon} />
                  {method.label}
                </Tab>
              ))}
            </TabsContainer>
          </div>

          {!!type && (
            <>
              {/* Header con icono y título */}
              <div className={styles.header}>
                <div className={styles.headerIcon}>
                  <img src={iconoTienda} alt="Icono pago en tienda" />
                </div>
                <h2 className={styles.headerTitle}>
                  Genera tu ficha de depósito{' '}
                  <span className={styles.headerTitleHighlight}>para pago en tiendas.</span>
                </h2>
              </div>

              {/* Instrucciones */}
              {/* {getInstructions() && (
                <div className={styles.instructionsContainer}>
                  <p className={styles.instructionsTitle}>
                    Instrucciones para realizar tu pago en efectivo.
                  </p>
                  {getInstructions()}
                </div>
              )} */}

              {/* Botón de acción */}
              <div className={styles.buttonContainer}>
                <button
                  className="payment-button"
                  onClick={processPayment}
                  disabled={isSubmitting || isInvalidAmount}
                >
                  <span className={styles.buttonText}>
                    {isSubmitting
                      ? 'Generando referencia...'
                      : `Generar ${!!order ? ' otra ' : ''} referencia`}
                  </span>
                  {!isSubmitting && (
                    <img
                      src={iconoBotonDescargaFicha}
                      alt="Icono descargar ficha"
                      className={styles.buttonIcon}
                    />
                  )}
                </button>
              </div>

              {/* Advertencia */}
              <div className={styles.warningBox}>
                <img src={iconoDisclaimer} alt="Icono advertencia" className={styles.warningIcon} />
                <div className={styles.warningContent}>
                  <div className={styles.warningTitle}>¡RECUERDA!</div>
                  <div className={styles.warningText}>
                    Los depósitos en tienda pueden tomar hasta 3 horas en verse el saldo reflejado
                    en tu cuenta.
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {order && (
        <div className={styles.orderInfo}>
          <p className={styles.warningText}>
            Gracias por tu compra, te enviamos por correo las instrucciones para realizar tu pago
            en efectivo.
          </p>

          <div className="text-center">
            <img
              src={order.barcodeUrl}
              className={`img-responsive ${styles.barcodeImage}`}
              alt="Código de barras"
            />
          </div>

          <div className={styles.reference}>{order.reference}</div>

          {getInstructionWithOrder()}

          <button
            className="payment-button"
            onClick={() => window.open(order.url, '_blank')}
            disabled={isSubmitting}
          >
            <span className={styles.buttonText}>Ver Referencia</span>
            <img
              src={iconoBotonDescargaFicha}
              alt="Icono descargar ficha"
              className={styles.buttonIcon}
            />
          </button>
          {/* 
          {!!type && (
            <div className={styles.buttonContainer}>
              <button
                className="payment-button"
                onClick={processPayment}
                disabled={isSubmitting || isInvalidAmount}
              >
                <span className={styles.buttonText}>
                  {isSubmitting
                    ? 'Generando referencia...'
                    : `Generar ${!!order ? ' otra ' : ''} referencia`}
                </span>
                {!isSubmitting && (
                  <img
                    src={iconoBotonDescargaFicha}
                    alt="Icono descargar ficha"
                    className={styles.buttonIcon}
                  />
                )}
              </button>
            </div>
          )} */}
        </div>
      )}
    </div>
  );
};
